demo:
  chrome:
    share: Teilen
